let html = `<div class="feed-head selector layer--visible">
    <div class="feed-head__icon">
        <img src="{mirror}/img/other/lampa_movie.jpg" class="feed-head__img" />
    </div>

    <div class="feed-head__body">
        <div class="feed-head__title"></div>
        <div class="feed-head__info"></div>
    </div>
</div>`

export default html